import React, { useState } from 'react';
import '../styles/ContactForm.css';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    alert('Thank you for your message! We will get back to you soon.');
    setFormData({
      name: '',
      email: '',
      phone: '',
      subject: '',
      message: ''
    });
  };

  return (
    <div className="contact-container">
      <div className="contact-header">
        <h1>The support team is here to help you</h1>
        <p>Get in touch and let us know how we can help...!</p>
      </div>

      <div className="contact-section">
        <div className="contact-info">
          <h2>CONTACT US</h2>
          
          <div className="contact-detail">
            <h5>Phone</h5>
            <p>+91 8508508590</p>
          </div>
          
          <div className="contact-detail">
            <h5>Email</h5>
            <p>mpeoplesofficial@gmail.com</p>
          </div>
          
          <div className="contact-detail">
            <h5>Office Address</h5>
            <address>
              1/248, Raja Ganapathy Complex,<br />
              2nd Floor, Opposite BSNL Office,<br />
              Meyyanur Main Road, Salem -636004.
            </address>
          </div>
        </div>

        <div className="contact-form">
          <h3>Enquiry</h3>
          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  className="form-control"
                  placeholder="Enter Name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  className="form-control"
                  placeholder="Enter Email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="phone">Phone</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  className="form-control"
                  placeholder="Enter Phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="subject">Subject</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  className="form-control"
                  placeholder="Enter Subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="message">Leave your message</label>
              <textarea
                id="message"
                name="message"
                className="form-control"
                placeholder="Enter message"
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
            </div>

            <button type="submit" className="submit-btn">
              SUBMIT
            </button>
          </form>
        </div>
      </div>

      <div className="contact-footer">
        <h3>Better discussions, better decisions</h3>
        <p>We are for everyone – Startups, Skills, Enterprises. Connect with us for a conversation.</p>
      </div>
    </div>
  );
};

export default ContactPage;